/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCouponBatchShopifyIssuedCustomerContext { 
    /**
     * Restrict redemption to the customer the code is issued to. On-demand batches only, since every issued code gets its own Shopify discount.
     */
    type: CreateCouponBatchShopifyIssuedCustomerContext.TypeEnum;
}
export namespace CreateCouponBatchShopifyIssuedCustomerContext {
    export const TypeEnum = {
        IssuedCustomer: 'issued_customer'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


